import { Component, Input, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
	selector: 'popover',
	template: require('./popover.component.html')
})
export class PopoverComponent {

	@Input('placement') placement: string = "top";

	@Input('name') name: string;

	@Input('info') info: {title: string, data: any[]};

	@Input('hasChanges') hasChanges: boolean;

	@Input('disabled') disabled: boolean = false;

	@Input('enableClearButton') enableClearButton: boolean = false;

	@Input('wrap') wrap: boolean = false;

	@Output('onShow') onShowCallback = new EventEmitter<any>();

	@Output('onSave') onSaveCallback = new EventEmitter<any>();

	@Output('onCancel') onCancelCallback = new EventEmitter<any>();

	@Output('onClear') onClearCallback = new EventEmitter<any>();



	saving: boolean = false;

	errorTitle: string = "";
	
	errorMessage: string = "";

	@ViewChild('pop')
	popover;

	test($event) {
		console.log($event);
	}

	get title() {
		if (this.name)
			return "Edit " + this.name;
		return "";
	}

	onHidden() {
		this.onCancel();
	}

	onShown() {
		this.onShowCallback.emit();
	}

	show() {

		this.popover.show();
	}

	hide() {

		if (this.popover.isOpen) {
			this.popover.hide();
		}
	}
	
	onChange() {
		this.errorTitle = null;
		this.errorMessage = null;
	}

	onCancel() {
		this.onCancelCallback.emit();
		this.errorTitle = null;
		this.errorMessage = "";
		this.popover.hide();
	}

	onSave() {
		this.saving = true;

		this.errorTitle = null;
		this.errorMessage = null;
		

		this.onSaveCallback.emit({
			resolve: () => {
				this.saving = false;
				this.hide();
			},
			reject: (response: HttpErrorResponse) => {

				console.dir(response);

				if (response) {

					//bad request
					if (response.status === 400) {
						this.errorTitle = "Bad request";
						this.errorMessage = `The value(s) was in the wrong format`;
					}

					//server error
					else if (response.status === 500) {
						this.errorTitle = "Error";
						this.errorMessage = `The server could not process the change`;
					}

					//conflict
					else if (response.status === 409) {
						this.errorTitle = "Conflict";
						this.errorMessage = `The server could not process the change because of conflicts with existing data`;
					}

					else if (response.status === 403) {
						this.errorTitle = "Unauthorized";
						this.errorMessage = `Not authorized to perform operation`;
					}

					else {
						this.errorTitle = "Error = " + response.status;
						this.errorMessage = "The server returned an unexpected response";
					}
				}

				this.saving = false;	
			}
		});

	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover.component.ts